import { getUrl } from 'utils'
import { translate } from 'utils/translations'
import ArrowRightFilledIcon from 'assets/svgr-icons/Arrow_Right_Filled.svg'
import ListItem from '../ListItem'
import * as Styled from './styled'
import { T } from 'consts/translationKeys'

const SignOutButton = () => {
  const href = getUrl('/logout')

  return (
    <Styled.SignOutButtonWrapper>
      <ListItem
        data={{
          id: 'sign-out',
          icon: ArrowRightFilledIcon,
          label: translate(T.SIGN_OUT_LABEL),
          url: href
        }}
      />
    </Styled.SignOutButtonWrapper>
  )
}

export default SignOutButton
